import { processComponentOption, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_f29d1196";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_f29d1196" };
/** script content **/
require("./rate-item-index.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Frate-itemf29d1196%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Frate%2Frate-item.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_f29d1196"],
    ctorType: "component",
    outputPath: "components/rate-itemf29d1196/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
